<template lang="html">
<div class="login">
  <div v-if="isPhone" class="container-table phone" :style="{height: contentHeight}">
    <div class="bg-img" :style="{  'background-image':`url(/static/${$store.state.theme.name}/phone_login_background.jpg)`}">
      <img class="m_logo" :src="`/static/${$store.state.theme.name}/logo_login.png`" alt="">
    </div>
    <div class="form">
      <el-form :model="form">
        <el-form-item>
          <el-input class="input" v-model="form.id" :placeholder="$t('Views.Login.id')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="password" class="input password" v-model="form.password" :placeholder="$t('Views.Login.pwd')"></el-input>
        </el-form-item>
        <!-- <el-form-item class="sl-captcha">
          <el-input class="input password" v-model="form.captcha" :placeholder="$t('Views.Login.captcha')" @keyup.enter.native="onLogin"></el-input>
          <img :src="captchaUrl" alt="CAPTCHA Image" @click="changeImg"/>
        </el-form-item> -->
        <el-form-item>
          <el-button class="btn" type="success" @click="onLogin" :loading="loginLoading">{{loginName}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <!-- for PC -->
  <div v-else class="container-table web" :style="{height: contentHeight}">
    <div class="bg-img" :style="{  'background-image':`url(/static/${$store.state.theme.name}/lgbg.png)`}">
      <!-- <img class="m_logo" :src="`/static/${$store.state.theme.name}/logo_login.png`" alt="">  -->
      </div>

    <div class="form">
      <el-form :model="form">
        <img class="m_logo" :src="`/static/${$store.state.theme.name}/logo_login.png`" alt="">
        <el-form-item>
          <el-input class="input" v-model="form.id" :placeholder="$t('Views.Login.id')" @keyup.enter.native="onLogin"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="password" class="input password" v-model="form.password" :placeholder="$t('Views.Login.pwd')" @keyup.enter.native="onLogin"></el-input>
        </el-form-item>
        <!-- <el-form-item class="sl-captcha">
          <el-input class="input password" v-model="form.captcha" :placeholder="$t('Views.Login.captcha')" @keyup.enter.native="onLogin"></el-input>
          <img :src="captchaUrl" alt="CAPTCHA Image" @click="changeImg"/>
        </el-form-item> -->
        <el-form-item>
          <el-button class="btn" type="success" @click="onLogin" :loading="loginLoading">{{loginName}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</div>
</template>

<script>
import api from '../api'
import * as types from '../store/types'
export default {
  name: 'Login',
  created() {
    this.form.id = this.$route.query.id !== undefined ? this.$route.query.id : ''
  },
  data() {
    return {
      loginLoading: false,
      // captchaTime: 0,
      form: {
        id: '',
        password: ''
        // captcha: ''
      }
    }
  },
  computed: {
    captchaUrl() {
      return '/client/securimage?' + this.captchaTime
    },
    loginName() {
      return this.loginLoading ? this.$t('Views.Login.loading') : this.$t('Views.Login.login')
    },
    contentHeight() {
      return document.documentElement.clientHeight + 'px'
    },
    isPhone() {
      const u = navigator.userAgent
      const versions = {
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1
      }
      if (versions.mobile || versions.android || versions.iPhone) {
        return true
      }
      return false
    }
  },
  methods: {
    changeImg() {
      this.captchaTime += 1
    },
    onLogin() {
      this.$ga.event('Link', 'Login', 'Login')
      const vm = this
      this.loginLoading = true
      api.Login({
        username: this.form.id,
        password: this.form.password
        // captcha: this.form.captcha,
        // t: new Date().getTime()
      }).then(res => {
        vm.loginLoading = false
        if (res.data.code === 200) {
          const path = getPath(res.data.data.menu[0])
          vm.$store.commit(types.SIGNIN, {
            result: res.data.data,
            index: path
          })
          vm.$store.commit(types.SLIDER, res.data.data)
          if (vm.$store.state.user.userinfo.onBoarding === '1') {
            // to on boarding 页面
            vm.$router.push({
              name: 'OB-ResetPwd'
            })
          } else if (vm.$store.state.user.userinfo.onBoarding === '2') {
            vm.$router.push({
              name: 'OB-Agreement'
            })
          } else if (vm.$store.state.user.userinfo.onBoarding === '3') {
            vm.$router.push({
              name: 'OB-ServiceFee'
            })
          } else {
            vm.$router.push({
              path: path
            })
          }
        } else {
          // vm.changeImg()
          vm.$notify.error({
            title: res.data.msg,
            message: vm.$t('Views.Login.msg')
          })
        }
        vm.loginLoading = false
      }).catch(error => {
        vm.loginLoading = false
        // vm.changeImg()
        vm.$notify.error({
          title: vm.$t('Notify.err'),
          message: error.msg
        })
      })
    }
  }
}

function getPath(arr) {
  let url = arr.url
  if (url === '#') {
    return arr.children[0].url
  }
  return url
}
</script>


<style>
.sl-captcha img {
  height: 50px;
  cursor: pointer;
}

.form .sl-captcha .input {
  width: 37%;
}

.container-table.web {
  height: 100%;
  min-height: 720px;
  background-color: #282B30 !important;
}

.bg-img {
  width: 100%;
  height: 100%;
  background-size:cover;
  /* 背景图垂直、水平均居中 */
  background-position: center center;
    /* 背景图不平铺 */
    background-repeat: no-repeat;
    /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
    background-attachment: fixed;
    /* 让背景图基于容器大小伸缩 */
    background-size: cover;
}

.bg-img .m_logo {
  width: 158px;
  position: absolute;
  left: 50%;
  margin-left: -79px;
  top: 15%;
}

.m_logo {
  width: 158px;
  margin-left: 100px;
}

.bg-color {
  width: 100%;
  height: 40%;
  /* background-color: #2f6ab7; */
}

.bg-color img {
  width: 84px;
  position: absolute;
  left: 50%;
  margin-left: -42px;
  bottom: 80px;
}

.bg-color .text {
  text-align: center;
  font-size: 12px;
  color: #9BCAF7;
  font-family: 'AvenirNext-Regular';
  position: absolute;
  bottom: 20px;
  width: 280px;
  left: 50%;
  margin-left: -140px;
}

.form {
  width: 400px;
height: 431px;
background: #FFFFFF;
border-radius: 20px;
  min-height: 240px;
  background: #FFFFFF;
  box-shadow: 2px -2px 4px 0 rgba(0, 0, 0, 0.20);
  padding-top: 50px;
  position: absolute;
  left: 70%;
  margin-left: -180px;
  top: 30%;
}

.form .input {
  background: #F9F9F9;
  border-radius: 2px;
  width: 330px;
  line-height: 60px;
  height: 60px;
  margin: 10px 30px;
}

.form input {
  line-height: 60px;
  height: 60px;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-checkbox {
  font-family: AvenirNext-Regular;
  font-size: 13px;
  color: #8F8F8F;
  letter-spacing: 0;
  line-height: 14px;
  font-weight: inherit;
}

.el-checkbox__inner {
  width: 16px;
  height: 16px;
}
::v-deep .el-input__inner{
          height: 60px;
        }

.form input:active {
  border: 1px solid #339CE2;
}

.form .btn {
  width: 330px;
height: 60px;
background: #295DB2;
border-radius: 8px;
  margin: 0 30px;
}

.register {
  text-align: center;
  font-weight: inherit;
  font-family: AvenirNext-Regular;
  font-size: 13px;
  color: #8F8F8F;
  letter-spacing: 0;
}

.register a {
  text-decoration: underline;
}

.remember_me {
  margin-left: 30px;
}

.forgot {
  float: right;
  margin-right: 20px;
  font-family: AvenirNext-Regular;
  font-size: 13px;
  color: #8F8F8F;
  letter-spacing: 0;
}

@media only screen and (max-width: 500px) {
  .bg-img {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .bg-img .logo {
    width: 68px;
    height: 21px;
    position: absolute;
    top: 23px;
    right: 23px;
  }
  .bg-img .m_logo {
    top: 16%;
  }
  .bg-color {
    height: 0 !important;
  }
  .form {
    background: none;
    border: none;
    box-shadow: none;
  }
  .form .input {
    background: #F9F9F9;
    border-radius: 2px;
    width: 84%;
    margin: 0 8%;
    line-height: 60px;
    height: 60px;
  }
  .forgot_id {
    line-height: 36px;
    position: relative;
    font-size: 14px;
    display: flex;
  }
  .form .btn {
    background: #156ABD;
    border-radius: 2px;
    height: 50px;
    width: 84%;
    margin: 0 8%;
  }
  .phone .register span {
    height: 50px;
    line-height: 50px;
    width: 84%;
    margin: 0 8%;
    border: 1px solid #5F5F5F;
    border-radius: 2px;
    color: #8f8f8f;
  }
  .phone .register span a {
    font-family: AvenirNext-Regular;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 19px;
    padding-left: 5px;
  }
  .phone .form {
    top: 45%;
  }
  .phone .sl-captcha img {
    height: 50px;
    cursor: pointer;
    position: absolute;
    right: 29px;
    width: 130px;
  }
  .phone .form .sl-captcha .input {
    width: 160px;
    margin: 0;
    position: relative;
    left: -71px;
  }
}

@media only screen and (max-width:320px) {
  .phone .form {
    top: 36%;
  }
}

.links {
  position: absolute;
  right: 20px;
}

.links a {
  display: inline-block;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// login.vue?5448037e